module.exports = __webpack_public_path__ + "img/Romania.4b682fa3.svg";